import { css } from '@emotion/react';
import {
  breakpointInfix,
  MediaBreakpointUp,
} from '../mixins/_breakpoints.mixin';

export default $ => css`
  ${Object.keys($.gridBreakpoints).map((breakpoint) => {
    const infix = breakpointInfix($, breakpoint, $.gridBreakpoints);
    return new MediaBreakpointUp(breakpoint).include($, css(
      $.displays.map((value) => (
        `.d${infix}-${value} { display: ${value} !important; }`
      ))
    ));
  })}

  @media print {
    ${$.displays.map((value) => (
      `.d-print-${value} { display: ${value} !important; }`
    ))}
  }
`;
